import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import "../../styles/styles.css";
import {Article} from "../../data/types";
import axios from "axios";

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageProjets = () => {
  const [articles, setArticles] = useState([])
    useEffect(() => {
      const getArticles = async () => {
        var response:any=[];
        try {
          response = await axiosInstance.get("api/articles/Projets");
          setArticles(response.data);
        } catch (error) {
          console.log("erreur:"+error);
        }
      }
      getArticles(); 
          
    }, [])

  
  return (
    <div className="stretch  bgColor">
        <div className="container py-6 lg:py-8 ">
          {/* HEADER */}
          <h2 className="inline-block align-middle text-4xl font-semibold md:text-5xl ">
            Projets&nbsp;
          </h2>
         
          <span className="block text-neutral-300">{articles.length} articles</span>
          {/* ====================== END HEADER ====================== */}
          <div className="mt-6 flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="block border-b w-full border-neutral-500 sm:hidden"></div>
            <div className="flex justify-end">
            </div>
          </div>
          {/* LOOP ITEMS */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 md:gap-x-8 md:gap-y-10 mt-8 lg:mt-10">
            {
              articles.map((post:any) => (
                <Card key={post.id} post={post} />  
              ))
            }
          </div>
        </div>
    </div> 
  );  
};

export default PageProjets;
